<script>
export default {
  name: 'UlFormItemBtn',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },
};
</script>
<template>
  <UlFormBtn
    :disabled="disabled"
    :title="title"
    :icon="icon"
    @click="$emit('click')"
  />
</template>
